import { render, staticRenderFns } from "./ConfigurazioneContabilitaTipiSoggettiEditModal.vue?vue&type=template&id=1cf03776"
import script from "./ConfigurazioneContabilitaTipiSoggettiEditModal.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneContabilitaTipiSoggettiEditModal.vue?vue&type=script&lang=js"
import style0 from "./ConfigurazioneContabilitaTipiSoggettiEditModal.vue?vue&type=style&index=0&id=1cf03776&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports